import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const MemberAvatar = styled.div`
    height: ${props => props.sizeMobile}px;
    width: ${props => props.sizeMobile}px;
    @media ${mediaQueries.md} {
        height: ${props => props.sizeDesktop}px;
        width: ${props => props.sizeDesktop}px;
    }
`;

const CardMemberAvatar = ({ photoURL, firstName, lastName, fullName, sizeMobile = 80, sizeDesktop = 180 }) => (
    <>
        {photoURL && (
            <MemberAvatar sizeDesktop={sizeDesktop} sizeMobile={sizeMobile}>
                <img
                    src={`${photoURL}?v=${Date.now()}`}
                    alt={fullName}
                    style={{ borderRadius: '100%', width: '100%', height: '100%' }}
                />
            </MemberAvatar>
        )}

        {!photoURL && (
            <MemberAvatar sizeDesktop={sizeDesktop} sizeMobile={sizeMobile}>
                <div
                    alt={fullName}
                    style={{ borderRadius: '100%', width: '100%', height: '100%' }}
                    className="member-default d-flex align-items-center"
                >
                    <div className="mx-auto letters">
                        {firstName && (
                            <span className="display5" style={{ fontSize: '0.75rem', color: 'black' }}>
                                {firstName.slice(0, 1)}
                            </span>
                        )}

                        {lastName && (
                            <span className="display5" style={{ fontSize: '0.75rem', color: 'black' }}>
                                {lastName.slice(0, 1)}
                            </span>
                        )}
                    </div>
                </div>
            </MemberAvatar>
        )}
    </>
);

CardMemberAvatar.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    fullName: PropTypes.string,
    photoURL: PropTypes.string,
    sizeMobile: PropTypes.number,
    sizeDesktop: PropTypes.number,
};

export default CardMemberAvatar;
